export const permissionsValidate = (permissions, Search) => {
  return permissions.findIndex(value => {
    return value.module === Search;
  });
};
